<!-- TEMPLATE -->
<template>
  <!-- SECTION MERCH -->
  <section id="merch" class="merch py-5">
    <!-- STEAM LINE -->
    <div class="container">
      <div class="row">
        <!-- MERCH -->
        <div
          class="col-12 col-xl-6 d-flex justify-content-center align-items-center"
        >
          <div class="col-12 text-center">
            <div
              class="py-2 pb-4"
              v-motion
              :initial="{
                opacity: 0,
                x: -100,
                transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'easeIn',
                },
              }"
              :visibleOnce="{
                opacity: 1,
                x: 0,
                transition: {
                  duration: 1200,
                  type: 'keyframes',
                  ease: 'easeOut',
                },
              }"
              :delay="100"
            >
              <!-- DESK -->
              <h2
                class="merch__text whiteneontxt fs-0 fw-bold d-none d-md-block"
              >
                GET THE OFFICIAL
                <b class="glowloop special-font"
                  ><a
                    class="special-font"
                    href="https://kerneldrip.com"
                    target="_blank"
                    >MERCH</a
                  ></b
                >
              </h2>
              <!-- MOBILE -->
              <h4
                class="merch__text whiteneontxt fs-0 fw-bold d-block d-md-none"
              >
                GET THE OFFICIAL
                <b class="glowloop special-font"
                  ><a
                    class="special-font"
                    href="https://kerneldrip.com"
                    target="_blank"
                    >MERCH</a
                  ></b
                >
              </h4>
            </div>

            <div
              class="glowloop-img pt-2"
              v-motion
              :initial="{
                opacity: 0,
                x: -100,
                transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'easeIn',
                },
              }"
              :visibleOnce="{
                opacity: 1,
                x: 0,
                transition: {
                  duration: 1200,
                  type: 'keyframes',
                  ease: 'easeOut',
                },
              }"
              :delay="200"
            >
              <a href="https://kerneldrip.com">
                <img src="../assets/img/misc/merch.png" alt="merch-image" />
              </a>
            </div>
          </div>
        </div>

        <!-- FORTNITE -->
        <div
          class="col-12 col-xl-6 d-flex justify-content-center align-items-center"
        >
          <div class="col-12 text-center">
            <div
              class="glow pt-2"
              v-motion
              :initial="{
                opacity: 0,
                x: 100,
                transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'easeIn',
                },
              }"
              :visibleOnce="{
                opacity: 1,
                x: 0,
                transition: {
                  duration: 1200,
                  type: 'keyframes',
                  ease: 'easeOut',
                },
              }"
              :delay="200"
            >
              <a
                href="https://store.epicgames.com/p/kernel-hearts-809ae2"
                target="_blank"
              >
                <img
                  src="../assets/img/misc/fortnite-fernet-outfit.png"
                  alt="fortnite-fernet-outfit-image"
                />
              </a>
            </div>

            <div
              class="py-2 mt-4 pb-2"
              v-motion
              :initial="{
                opacity: 0,
                x: 100,
                transition: {
                  duration: 400,
                  type: 'keyframes',
                  ease: 'easeIn',
                },
              }"
              :visibleOnce="{
                opacity: 1,
                x: 0,
                transition: {
                  duration: 1200,
                  type: 'keyframes',
                  ease: 'easeOut',
                },
              }"
              :delay="100"
            >
              <!-- DESK -->
              <h2
                class="merch__text whiteneontxt fs-0 fw-bold d-none d-md-block"
              >
                CLAIM YOURS
                <b class="glowloop special-font"
                  ><a
                    class="special-font"
                    href="https://store.epicgames.com/p/kernel-hearts-809ae2"
                    target="_blank"
                    >HERE</a
                  ></b
                >
              </h2>
              <!-- MOBILE -->
              <h4
                class="merch__text whiteneontxt fs-0 fw-bold d-block d-md-none"
              >
                CLAIM YOURS
                <b class="glowloop special-font"
                  ><a
                    class="special-font"
                    href="https://store.epicgames.com/p/kernel-hearts-809ae2"
                    target="_blank"
                    >HERE</a
                  ></b
                >
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "MerchComponent",
  // props: {},
  data: function () {
    return {};
  },
  // computed: {},
  // methods: {},
  // watch: {},
  // components: {},
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  // -- End Lifecycle Methods
};
</script>

<!-- STYLE -->
<style lang="scss" scoped>
a {
  text-decoration: none;
  color: var(--color5);
  transition: 0.3s linear;

  &:hover {
    cursor: pointer;
    text-shadow: rgba(219, 25, 171, 1) 0px 0px 8px;
  }
}

section {
  width: 100vw;
}

img {
  max-width: 100%;
  height: auto;
  transition: 0.3s;

  &:hover {
    cursor: pointer;
    filter: drop-shadow(0px 0px 12px rgba(var(--color4rgba), 0.4));
  }
}

.merch {
  background: url(../assets/img/bg/jpg/bgdiv.jpg) rgba(var(--color3rgba, 0.1));
  background-size: cover;
  background-blend-mode: multiply;
  background-position: center;
  background-repeat: no-repeat;
  filter: drop-shadow(0px 0px 12px rgba(20, 14, 22, 0.9));

  &__text {
    font-family: var(--ff2);
    font-size: var(--h2);
    transform: scale(0.94, 1.5);
    letter-spacing: 0.2rem;
  }

  &__text2 {
    display: inline-block;
    font-family: var(--ff2);
    font-size: var(--h2);
    transform: scale(0.94, 1.3);
    letter-spacing: 0.2rem;
  }

  &__discord {
    font-size: var(--h2);
  }
}

.glowloop-img {
  animation: glowing-img 3800ms infinite;
}

@keyframes glowing-img {
  0% {
    filter: drop-shadow(0px 0px 12px rgba(var(--color4rgba), 0.4));
  }

  50% {
    filter: drop-shadow(0px 0px 12px rgba(var(--color3rgba), 1));
  }

  100% {
    filter: drop-shadow(0px 0px 12px rgba(var(--color4rgba), 0.4));
  }
}

.glowloop {
  animation: glowing 3800ms infinite;
}

@keyframes glowing {
  0% {
    filter: drop-shadow(0px 0px 2px rgba(var(--color4rgba), 0.4));
  }

  50% {
    filter: drop-shadow(0px 0px 4px rgba(var(--color3rgba), 1));
  }

  100% {
    filter: drop-shadow(0px 0px 2px rgba(var(--color4rgba), 0.4));
  }
}

.glow {
  filter: drop-shadow(0px 0px 16px rgba(var(--color4rgba), 0.2));
}

.special-font {
  font-family: var(--ff2) !important;
}
</style>
